<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">广告主ID：</label>
          <el-input
            v-model="advertisersQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          @click="add"
        >创建</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between;"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
          width="80"
        />

        <el-table-column
          prop="account_id"
          label="广告主账户id"
          align="center"
        />
        <el-table-column
          prop="feedback_id"
          label="监测链接组 id"
          align="center"
        />
        <el-table-column
          prop="feedback_name"
          label="监测链接组名称"
          align="center"
        />
        <el-table-column
          prop="version_num"
          label=""
          align="center"
        />

        <el-table-column
          prop="second_category_type"
          label="营销载体类型"
          align="center"
        />
        <el-table-column
          prop="second_category_type_int"
          label="营销载体类型id"
          align="center"
        />
        <el-table-column
          prop="url_info_list"
          label="监测链接组信息"
          type="expand"
          align="center"
        >
          <template slot-scope="props">
            <el-form
              v-for="item,index in props.row.url_info_list "
              :key="item.id"
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-divider content-position="center">第{{ index+1 }}条</el-divider>

              <el-form-item label="id">
                <span>{{ item.id }}</span>
              </el-form-item>
              <el-form-item label="监测链接id">
                <span>{{ item.feedback_id }}</span>
              </el-form-item>
              <el-form-item
                v-if="item.feedback_name"
                label="监测链接名称"
              >
                <span>{{ item.feedback_name }}</span>
              </el-form-item>
              <el-form-item
                v-if="item.type_name"
                label="类型名称
"
              >
                <span>{{ item.type_name }}</span>
              </el-form-item>
              <el-form-item label="监测链接类型">
                <span>{{ item.feedback_type }}</span>
              </el-form-item>
              <el-form-item label="监测链接">
                <el-tooltip
                  :content="item.feedback_url "
                  placement="top"
                >
                  <span
                    class="url-wrapper"
                    @click="copy(item)"
                  >
                    {{ item.feedback_url }}
                  </span>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ item.create_time }}</span>
              </el-form-item>
            </el-form>
          </template>

        </el-table-column>

        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        />
        <el-table-column
          prop="modify_time"
          label="最近操作时间"
          align="center"
        />
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="add(scope.row)"
            >创建</el-button>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="last_modified_time"
          label="最后修改时间"
          align="center"
          width="180"
        /> -->
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="创建监测链接组"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
    >
      <brandDialog
        ref="add"
        @submit="submit"
      />
    </el-dialog>
  </div>
</template>

<script>
import brandDialog from './components/feedbackInfoDialog.vue'

import { feedback_info, feedback_infoCreate } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import detailsList from '../../customer/accountList/components/details.vue'
export default {
  name: 'FeedbackInfo',
  components: {
    PaginationRight,
    brandDialog
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        account_id: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    async submit(obj, fu) {
      await feedback_infoCreate(obj)
      this.$message.success('创建成功')
      setTimeout(() => {
        this.getAdvertiserList()
      }, 2 * 60 * 1000)
      this.handleClose()
      fu()
    },
    handleClose() {
      this.dialogVisible = false
    },
    add(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.send(row)
      })
    },
    getAdvertiserList() {
      this.loading = true
      feedback_info(this.advertisersQuery).then(res => {
        console.log('res5:', res)
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
        console.log(22)
      })
    },
    copy(data) {
      const newdata = data.feedback_url
      if (navigator.clipboard) {
        console.log(1)
        navigator.clipboard.writeText(newdata)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = newdata
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {
        account_id: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 120px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.url-wrapper {
  color: blue;
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
